// extracted by mini-css-extract-plugin
export default {"wrapper":"nri2Na4ne9xKoxOYL3il","highlightzone":"pIKyPQiIgrGRXeQSp6ps"};